import React from 'react';

import { MCButton, TextField } from 'src/components/basic';
import { MediaDropBox } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss } from 'src/helpers';
import LANG_CONST from '../../helpers/lang/const';

class AddAnalyse extends BaseComponent {
  apiId = 'create';
  componentDidMount() {
    this.props.model.baseSubscribe(this.subscription);
    this.props.model.resetAddAnalyse(this.props.item);
    this.apiId = this.props.item ? 'edit' : 'create';
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
  }

  create = (event) => {
    event.preventDefault();
    const { hide, item } = this.props;
    if (item)
      return this.props.model.edit((error, data, success) => {
        if (success) hide();
      });
    this.props.model.create((error, data, success) => {
      if (success) hide();
    });
  };

  render() {
    const { closeBtn, model, hide, item } = this.props;
    let { invalid, loading, error, errorMessage } = model.getApiState(this.apiId);
    if (error === 'FILE_TYPE_NOT_ALLOWED') errorMessage = LANG_CONST.validation.file_invalid;
    return (
      <div className='mc-popup-contain' style={{ width: remCss(600) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>
            {lang.t(!item ? LANG_CONST.titles.add_analyses : LANG_CONST.titles.edit_analyses)}
          </div>
          {closeBtn}
        </div>
        <form className='mc-modal-body mc-flex-15-col' onSubmit={this.create}>
          <TextField
            template={5}
            name={'title'}
            validate='analyseTitle'
            label={LANG_CONST.title}
            placeholder={LANG_CONST.add_your_title}
            disabled={loading}
            value={model.listInput('title')}
            onChange={model.listHandleChange}
            onBlur={(key, value) => {
              model.handleBlur(key, value, this.apiId);
            }}
            invalid={invalid}
          />
          <div className={'mc-flex-10-col'}>
            <div className={'mc-value-420'}>{lang.t(LANG_CONST.photos_files)}</div>
            <MediaDropBox
              template={2}
              name={'files'}
              media={model.listInput('media') || []}
              labelIcon={LANG_CONST.buttons.add_file}
              multi={false}
              value={model.listInput('files') !== '' ? model.listInput('files') : []}
              onChange={(n, v) => {
                model.resetApiState(this.apiId);
                model.listHandleFiles(n, v);
                if (v?.length > 0) model.listHandleFiles('media', []);
              }}
              onChangeMedia={() => {
                model.resetApiState(this.apiId);
                model.listHandleFiles('media', []);
              }}
            />
            {invalid && invalid.files && (
              <div className='mc-form-invalid-text'>{invalid.files}</div>
            )}
          </div>
        </form>
        {!!errorMessage && <div className='mc-error'>{lang.t(errorMessage)}</div>}
        <div className='mc-modal-footer mc-flex'>
          <div className={'mc-grow'} />
          <MCButton
            medium
            primary
            radius
            light
            disabled={loading}
            style={{ width: remCss(120) }}
            type={'button'}
            onClick={hide}
            label={LANG_CONST.buttons.cancel}
          />
          <MCButton
            medium
            primary
            radius
            dark
            disabled={loading}
            loading={loading}
            style={{ width: remCss(120) }}
            type={'submit'}
            onClick={this.create}
            label={item ? LANG_CONST.buttons.edit : LANG_CONST.buttons.create}
          />
        </div>
      </div>
    );
  }
}

export default AddAnalyse;
